import { render } from "./NavBarTitle.vue?vue&type=template&id=808eb854"
import script from "./NavBarTitle.vue?vue&type=script&lang=js"
export * from "./NavBarTitle.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__